import * as PIXI from "pixi.js";
import ServiceLocator from "../../ServiceLocator";
import Player from "./Player";


export default class Card extends PIXI.Container
{
    private _id: number = null;
    private _color: card_color_type = null;
    private _value: card_value_type = null;

    private _owner: Player = null;

    private _face: PIXI.Sprite = null;
    private _shade: PIXI.Sprite = null;
    private _highlight: PIXI.Sprite = null;

    private _faceTexture: PIXI.Texture = null;

    private _shadow: PIXI.Sprite = null;

    private _isFaceUp: boolean = null;


    public set id( value: number ) { this._id = value; }
    public set color( value: card_color_type ) { this._color = value; }
    public set value( value: card_value_type ) { this._value = value; }
    public set owner( value: Player ) { this._owner = value; }
    public set shadow( value: PIXI.Sprite ) { this._shadow = value; }

    public get id(): number { return this._id; }
    public get color(): card_color_type { return this._color; }
    public get value(): card_value_type { return this._value; }
    public get owner(): Player { return this._owner; }
    public get shade(): PIXI.Sprite { return this._shade; }
    public get isFaceUp(): boolean { return this._isFaceUp; }
    public get faceTexture(): PIXI.Texture { return this._face.texture; }
    public get shadow(): PIXI.Sprite { return this._shadow; }

    public static get kHalfWidth(): number { return 50; }
    public static get kWidth(): number { return 100; }


    public constructor()
    {
        super();
    }

    public init(): void
    {
        console.assert( this._id !== null, "Card.ts :: init() :: this._id cannot be null." );
        console.assert( this._color !== null, "Card.ts :: init() :: this._color cannot be null." );
        console.assert( this._value !== null, "Card.ts :: init() :: this._value cannot be null." );
    
        this._face = new PIXI.Sprite();
        this._face.scale.set( 0.5 );
        this._face.anchor.set( 0.5 );
        this.addChild( this._face );

        let deckId: string = "deck_";
        let faceTextureId = [ "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "s", "r", "d", "w", "h" ][ this._value ];
        switch ( this._color )
        {
            case card_color_type.RED: { faceTextureId += "r"; deckId += "ry"; break; }
            case card_color_type.YELLOW: { faceTextureId += "y"; deckId += "ry"; break; }
            case card_color_type.BLUE: { faceTextureId += "b"; deckId += "gb"; break; }
            case card_color_type.GREEN: { faceTextureId += "g"; deckId += "gb"; break; }
            case card_color_type.ANY: { faceTextureId += "a"; deckId += "s"; break; }
        }

        this._faceTexture = ServiceLocator.resources[ deckId ].textures[ faceTextureId + ".png" ];
        this._face.texture = ServiceLocator.resources.deck_s.textures[ "back.png" ];

        this._shade = new PIXI.Sprite( ServiceLocator.resources.card_shade.texture );
        this._shade.anchor.set( 0.5 );
        this._shade.visible = false;
        this.addChild( this._shade );

        this._isFaceUp = false;
    }

    public end(): void
    {
        // TODO:
    }

    public setFaceUp(): void
    {
        this._isFaceUp = true;

        this._face.texture = this._faceTexture;
    }

    public setFaceDown(): void
    {
        this._isFaceUp = false;

        this._face.texture = ServiceLocator.resources.deck_s.textures[ "back.png" ];
    }

    public setColor( color: card_color_type ): void
    {
        this._color = color;

        let deckId: string = "deck_";
        let faceTextureId = [ "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "s", "r", "d", "w", "h" ][ this._value ];
        switch ( color )
        {
            case card_color_type.RED: { faceTextureId += "r"; deckId += "ry"; break; }
            case card_color_type.YELLOW: { faceTextureId += "y"; deckId += "ry"; break; }
            case card_color_type.BLUE: { faceTextureId += "b"; deckId += "gb"; break; }
            case card_color_type.GREEN: { faceTextureId += "g"; deckId += "gb"; break; }
            case card_color_type.ANY: { faceTextureId += "a"; deckId += "s"; break; }
        }

        this._faceTexture = ServiceLocator.resources[ deckId ].textures[ faceTextureId + ".png" ];
        if ( this._isFaceUp )
        {
            this._face.texture = this._faceTexture;
        }
    }

    public setHighlighted( isHighlighted: boolean ): void
    {
        if ( isHighlighted )
        {
            if ( !this._highlight )
            {
                this._highlight = new PIXI.Sprite( ServiceLocator.resources.card_highlight.texture );
                this._highlight.anchor.set( 0.5 );
                this.addChild( this._highlight );
            }
        }
        else
        {
            if ( this._highlight )
            {
                this.removeChild( this._highlight );
                this._highlight.destroy();

                this._highlight = null;
            }
        }
    }
}

export const enum card_color_type
{
    RED = 0,
    YELLOW,
    BLUE,
    GREEN,
    ANY
}

export const enum card_value_type
{
    ZERO = 0,
    ONE,
    TWO,
    THREE,
    FOUR,
    FIVE,
    SIX,
    SEVEN,
    EIGHT,
    NINE,
    SKIP,
    REVERSE,
    DRAW_TWO,
    WILD_DRAW_FOUR
}